import { z } from 'zod';
/**
 * What a campaign or a template is written as, over the wire.
 *
 * Tagged rather than guessed. A body that arrived as markup could in principle
 * be detected by looking for a `<`, and that guess would be wrong the first
 * time somebody typed one — and being wrong here means either escaping a design
 * into visible tags or sending a person's prose as unescaped markup.
 *
 * The tag also decides which editor opens. Prose reopens in a textarea and a
 * design reopens in the builder; without it, a design could be sent and never
 * edited again.
 */
/**
 * The html is capped well below what a mail client will actually accept.
 *
 * Gmail clips a message over about 102 KB and shows a "view entire message"
 * link, which hides the unsubscribe footer — so a design approaching this limit
 * is already a problem for a different reason. The cap here is a guard against
 * a runaway paste rather than a quality bar; warning somebody that their design
 * will be clipped belongs on the pre-send checklist and is not built yet.
 */
const MOST_HTML = 400_000;
/** The builder's own project state. Larger than the html it produces, and never sent. */
const MOST_SOURCE = 2_000_000;
export const emailBodySchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('prose'),
        text: z.string().trim().min(1, 'a campaign needs something to say').max(50_000),
    }),
    z.object({
        kind: z.literal('designed'),
        html: z.string().trim().min(1, 'a campaign needs something to say').max(MOST_HTML),
        /**
         * Empty is a real state, not a missing value.
         *
         * A design that came from the AI designer arrives as finished html with no
         * builder project behind it. It opens in the builder perfectly well — the
         * builder can read html — and gains a project the first time it is saved.
         */
        source: z.string().max(MOST_SOURCE),
    }),
]);
//# sourceMappingURL=emailBody.js.map